<div *ngIf="device == 'desktop'" class="card">

    <div class="floating-map-overlays">
        <div *ngIf="isUsuarioInterno" class="floating-statistics"
            [class.floating-statistics-collapsed]="isHiddenStatistics">
            <div *ngIf="!isHiddenStatistics" class="floating-panel-header">
                <h5 class="m-0">Estatísticas da seleção</h5>
                <button pButton pRipple type="button" (click)="toggleEstatisticas()"
                    icon="pi pi-arrow-down" pTooltip="Ocultar" class="p-button-rounded p-button-text"></button>
            </div>

            <div *ngIf="isHiddenStatistics" class="floating-statistics-collapsed-content">
                <button pButton pRipple type="button" (click)="toggleEstatisticas()"
                    icon="pi pi-chart-bar" label="Estatísticas" class="p-button-text p-button-sm"></button>
            </div>

            <div *ngIf="!isHiddenStatistics" class="floating-statistics-body">
                <p class="estatisticas-modal-subtitle" *ngIf="estatisticasSelecao.total > 0">
                    {{ estatisticasSelecao.total }} estaç{{ estatisticasSelecao.total === 1 ? 'ão' : 'ões' }}
                </p>

                <p-message *ngIf="estatisticasSelecao.total === 0"
                    severity="info"
                    text="Nenhuma estação na seleção atual."
                    styleClass="estatisticas-modal-empty-message"></p-message>

                <ul *ngIf="estatisticasSelecao.total > 0" class="estatisticas-list">
                    <li *ngFor="let item of estatisticasSelecao.itens" class="estatisticas-item">
                        <span [class]="item.dotClass"></span>
                        <span class="estatisticas-item-label">{{ item.label }}</span>
                        <span class="estatisticas-item-values">
                            <strong>{{ item.quantidade }}</strong>
                            <span class="estatisticas-item-pct">({{ item.percentual }}%)</span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>

    </div>

    <div *ngIf="isHidden" class="floating-bar-collapsed-toggle">
        <button pButton pRipple type="button" (click)="toggleFloatingBar()" icon="pi pi-arrow-down"
            label="Exibir" class="p-button-text p-button-sm"></button>
    </div>

    <div id="floating-bar" class="floating-bar" [class.hidden]="isHidden">

        <!-- Botão ocultar no topo -->
        <div class="floating-bar-top">
            <button pButton pRipple type="button" (click)="toggleFloatingBar()" icon="pi pi-arrow-up"
                pTooltip="Ocultar" class="p-button-rounded p-button-text"></button>
        </div>

        <!-- Inputs -->
        <div class="formgrid p-fluid grid col-12 floating-bar-grid">
            <div class="field col-12 md:col-12 xl:col-7">
                <label class="block mb-1">Estações</label>
                <p-multiSelect [options]="dropDownEstacao" appendTo="body" [filter]="true" filterLocale="pt-BR" [(ngModel)]="estacao_id"
                    (click)="listEstacoes()"
                    optionLabel="label" placeholder="Todas as estações" styleClass="w-full">
                </p-multiSelect>
            </div>

            <div class="field col-12 md:col-12 xl:col-5">
                <label for="data_filtro_desktop" class="block mb-1">Data *</label>
                <input id="data_filtro_desktop" type="date" class="date-input w-full" [(ngModel)]="data_filtro" pInputText>
            </div>

            <div *ngIf="exibirFiltroAvancado" class="formgrid p-fluid grid col-12">

                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1">Grupos</label>
                    <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                        optionLabel="label" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1">Cliente</label>
                    <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                        optionLabel="label" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1">Sensores (Identificador)</label>
                    <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                        optionLabel="label" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-4" *ngIf="isUsuarioInterno">
                    <label class="block mb-1">Situação</label>
                    <p-multiSelect [options]="dropDownCores" appendTo="body" [filter]="true" [(ngModel)]="coresSelecionadas"
                        optionLabel="label" optionValue="value" placeholder="Todas" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label for="plu_filtro" class="block mb-1">PLU</label>
                    <input id="plu_filtro" type="text" [(ngModel)]="plu_filtro" pInputText class="w-full">
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label for="flu_filtro" class="block mb-1">FLU</label>
                    <input id="flu_filtro" type="text" [(ngModel)]="flu_filtro" pInputText class="w-full">
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label class="block mb-1">Integrador</label>
                    <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                        [(ngModel)]="integrador_filtro" optionLabel="descricao" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label class="block mb-1">Coletor</label>
                    <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                        [(ngModel)]="coletor_filtro" optionLabel="descricao" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-5" *ngIf="isUsuarioInterno">
                    <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                        icon="pi pi-plus" class="p-button-success"></button>
                </div>
            </div>
        </div>

        <!-- Botões de ação na base, centralizados lado a lado -->
        <div class="floating-bar-bottom-actions">
            <button pButton pRipple type="button" [disabled]="data_filtro == null" (click)="showMap()"
                icon="pi pi-search" class="p-button-rounded p-button-success"></button>
            <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain"></button>
        </div>

    </div>

    <div class="map-shell" [class.map-shell-loading]="!googleMapsReady">
        <div *ngIf="!googleMapsReady" class="map-loading-state">
            <p-progressSpinner></p-progressSpinner>
            <span>Carregando mapa...</span>
        </div>

        <div #mapCanvas class="native-map-canvas"></div>
    </div>
</div>

<div *ngIf="device == 'mobile'" class="mobile">

    <!-- Card flutuante de filtro (análogo ao floating-bar do desktop) -->
    <div class="mobile-floating-bar" [class.hidden]="isFilterMobileHidden">

        <!-- Botão ocultar no topo -->
        <div class="floating-bar-top">
            <button pButton pRipple type="button" (click)="toggleFilterMobile()" icon="pi pi-arrow-up"
                pTooltip="Ocultar" class="p-button-rounded p-button-text"></button>
        </div>

        <!-- Inputs -->
        <div class="formgrid p-fluid grid col-12 floating-bar-grid mobile-filter-body">
            <div class="field col-12">
                <label class="block mb-1">Estações</label>
                <p-multiSelect class="custom-multiselect" [options]="dropDownEstacao" appendTo="body" [filter]="true" filterLocale="pt-BR"
                    (click)="listEstacoes()"
                    [(ngModel)]="estacao_id" optionLabel="label" placeholder="Todas as estações"
                    [panelStyle]="{'width':'400px'}" styleClass="w-full">
                </p-multiSelect>
            </div>

            <div class="field col-12">
                <label for="data_filtro_mobile" class="block mb-1">Data *</label>
                <input id="data_filtro_mobile" type="date" class="date-input w-full" [(ngModel)]="data_filtro" pInputText>
            </div>

            <div *ngIf="exibirFiltroAvancado" class="formgrid p-fluid grid col-12">
                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1">Grupos</label>
                    <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                        optionLabel="label" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1">Cliente</label>
                    <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                        optionLabel="label" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1">Sensores (Identificador)</label>
                    <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                        optionLabel="label" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12" *ngIf="isUsuarioInterno">
                    <label class="block mb-1">Situação</label>
                    <p-multiSelect [options]="dropDownCores" appendTo="body" [filter]="true" [(ngModel)]="coresSelecionadas"
                        optionLabel="label" optionValue="value" placeholder="Todas" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-12">
                    <label for="plu_filtro_mobile" class="block mb-1">PLU</label>
                    <input id="plu_filtro_mobile" type="text" [(ngModel)]="plu_filtro" pInputText class="w-full">
                </div>
                <div class="field col-12 md:col-12 xl:col-12">
                    <label for="flu_filtro_mobile" class="block mb-1">FLU</label>
                    <input id="flu_filtro_mobile" type="text" [(ngModel)]="flu_filtro" pInputText class="w-full">
                </div>
                <div class="field col-12 md:col-12 xl:col-12">
                    <label class="block mb-1">Integrador</label>
                    <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                        [(ngModel)]="integrador_filtro" optionLabel="descricao" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-12">
                    <label class="block mb-1">Coletor</label>
                    <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                        [(ngModel)]="coletor_filtro" optionLabel="descricao" placeholder="Todos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12" *ngIf="isUsuarioInterno">
                    <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                        icon="pi pi-plus" class="p-button-success"></button>
                </div>
            </div>
        </div>

        <!-- Botões de ação na base, centralizados lado a lado -->
        <div class="floating-bar-bottom-actions">
            <button pButton pRipple type="button" [disabled]="data_filtro == null" (click)="showMap()"
                icon="pi pi-search" class="p-button-rounded p-button-success"></button>
            <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain"></button>
        </div>

    </div>

    <!-- Botão para exibir o filtro quando oculto -->
    <div *ngIf="isFilterMobileHidden" class="mobile-filter-collapsed-toggle">
        <button pButton pRipple type="button" (click)="toggleFilterMobile()" icon="pi pi-arrow-down"
            label="Exibir" class="p-button-text p-button-sm"></button>
    </div>

    <!-- Legenda de eventos flutuante + estatísticas (interno) -->
    <div class="floating-map-overlays">
        <div *ngIf="isUsuarioInterno" class="floating-statistics"
            [class.floating-statistics-collapsed]="isHiddenStatistics">
            <div *ngIf="!isHiddenStatistics" class="floating-panel-header">
                <h5 class="m-0">Estatísticas da seleção</h5>
                <button pButton pRipple type="button" (click)="toggleEstatisticas()"
                    icon="pi pi-arrow-down" pTooltip="Ocultar" class="p-button-rounded p-button-text"></button>
            </div>

            <div *ngIf="isHiddenStatistics" class="floating-statistics-collapsed-content">
                <button pButton pRipple type="button" (click)="toggleEstatisticas()"
                    icon="pi pi-chart-bar" label="Estatísticas" class="p-button-text p-button-sm"></button>
            </div>

            <div *ngIf="!isHiddenStatistics" class="floating-statistics-body">
                <p class="estatisticas-modal-subtitle" *ngIf="estatisticasSelecao.total > 0">
                    {{ estatisticasSelecao.total }} estaç{{ estatisticasSelecao.total === 1 ? 'ão' : 'ões' }}
                </p>

                <p-message *ngIf="estatisticasSelecao.total === 0"
                    severity="info"
                    text="Nenhuma estação na seleção atual."
                    styleClass="estatisticas-modal-empty-message"></p-message>

                <ul *ngIf="estatisticasSelecao.total > 0" class="estatisticas-list">
                    <li *ngFor="let item of estatisticasSelecao.itens" class="estatisticas-item">
                        <span [class]="item.dotClass"></span>
                        <span class="estatisticas-item-label">{{ item.label }}</span>
                        <span class="estatisticas-item-values">
                            <strong>{{ item.quantidade }}</strong>
                            <span class="estatisticas-item-pct">({{ item.percentual }}%)</span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>

    </div>

    <!-- Mapa ocupa toda a área de conteúdo -->
    <div class="map-shell" [class.map-shell-loading]="!googleMapsReady">
        <div *ngIf="!googleMapsReady" class="map-loading-state">
            <p-progressSpinner></p-progressSpinner>
            <span>Carregando mapa...</span>
        </div>
        <div #mapCanvas class="native-map-canvas"></div>
    </div>

</div>

<div *ngIf="hoverHintVisible && hoverHintNome" class="municipio-hover-hint"
    [ngStyle]="{'left.px': hoverHintPosition.x, 'top.px': hoverHintPosition.y}">
    <span class="municipio-hover-dot"></span>
    <span class="municipio-hover-text">{{ hoverHintNome }}</span>
</div>

<p-dialog [(visible)]="modalMunicipio"
    [header]="municipioSelecionado?.nome || 'Município'"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '480px', maxWidth: '95vw'}"
    styleClass="municipio-modal">

    <div class="municipio-modal-body">
        <p class="municipio-modal-subtitle">
            Estações dentro do município ({{ estacoesMunicipio.length }})
        </p>

        <p-message *ngIf="estacoesMunicipio.length === 0"
            severity="info"
            text="Nenhuma estação encontrada neste município."
            styleClass="municipio-modal-empty-message"></p-message>

        <ul *ngIf="estacoesMunicipio.length > 0" class="municipio-estacoes-list">
            <li *ngFor="let estacao of estacoesMunicipio" class="municipio-estacao-item">
                <i class="pi pi-map-marker municipio-estacao-icon"></i>
                <span class="municipio-estacao-nome">{{ estacao.descricao }}</span>
            </li>
        </ul>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Fechar" icon="pi pi-times"
            class="p-button-text" (click)="fecharDialogMunicipio()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="modal" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}" 
    [modal]="true" [draggable]="false" [resizable]="false" styleClass="station-modal">

    <ng-template pTemplate="header">
        <div class="modal-header-content">
            <a [routerLink]="['/dashboard/', estacao?.id, data_rota]" class="modal-header-link">
                <i class="pi pi-external-link modal-header-icon"></i>
                <h5 class="modal-header-title">{{ tituloModal }}</h5>
            </a>
        </div>
    </ng-template>

    <div class="modal-content">
        <!-- Informações da Estação -->
        <div class="station-info-card">
            <div class="station-info-header">
                <i class="pi pi-info-circle station-info-icon"></i>
                <h6 class="station-info-title">Informações da Estação</h6>
            </div>
            <div class="station-info-body">
                <div class="info-row">
                    <span class="info-label">ID:</span>
                    <span class="info-value">{{ estacao?.id }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Cód. PLU:</span>
                    <span class="info-value">{{ estacao?.plu }}</span>
                    <span class="info-label info-label-spaced">Cód. FLU:</span>
                    <span class="info-value">{{ estacao?.flu }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Localização:</span>
                    <span class="info-value">{{ estacao?.latitude }}, {{ estacao?.longitude }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="loading" class="map-loading-state">
            <p-progressSpinner></p-progressSpinner>
            <span>Carregando detalhes da estação...</span>
        </div>

        <!-- Grid de Eventos e Monitoramentos -->
        <div class="p-fluid grid modal-sections" *ngIf="loading == false">
            <!-- Seção de eventos -->
            <div class="col-12 md:col-6">
                <div class="events-card">
                    <div class="card-header">
                        <i class="pi pi-calendar-times card-header-icon"></i>
                        <h6 class="card-header-title">Eventos</h6>
                    </div>
                    <div class="card-body">
                        <div *ngFor="let item of data">
                            <p-message *ngIf="item.eventos.length === 0" severity="info" 
                                text="Nenhum evento encontrado." styleClass="empty-message"></p-message>
                            <div *ngFor="let row of item.eventos" class="event-row">
                                <div class="event-icon">
                                    <i [ngClass]="getIconeEvento(row)" [ngStyle]="{'color': row.cor}"></i>
                                </div>
                                <div class="event-content">
                                    <span class="event-name">{{ row.tipo_evento.descricao }}</span>
                                    <span class="event-count" [pTooltip]="row.tooltip">
                                        {{ row.total_computado }} / {{ row.maximo_normalidade_eventos }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Seção de monitoramento -->
            <div class="col-12 md:col-6">
                <div class="monitoring-card">
                    <div class="card-header monitoring-card-header">
                        <div class="card-header-title-group">
                            <i class="pi pi-eye card-header-icon"></i>
                            <h6 class="card-header-title">Monitoramentos</h6>
                        </div>
                        <button *ngIf="podeAbrirMonitoramento" pButton pRipple type="button"
                            icon="pi pi-plus"
                            label="Novo"
                            class="p-button-sm p-button-outlined monitoring-new-btn"
                            pTooltip="Criar novo monitoramento"
                            [disabled]="loading || !estacao?.id"
                            (click)="abrirNovoMonitoramentoEstacao($event)"></button>
                    </div>
                    <div class="card-body">
                        <div *ngFor="let item of data">
                            <p-message *ngIf="item.monitoramento.length === 0" severity="info"
                                text="Nenhum monitoramento encontrado." styleClass="empty-message"></p-message>
                            <div *ngFor="let row of item.monitoramento" class="monitoring-row"
                                [class.monitoring-row-clickable]="podeAbrirMonitoramento && !!row.id"
                                (click)="abrirMonitoramentoEstacao(row)">
                                <div class="monitoring-icon">
                                    <i [ngClass]="getIconeMonitoramento(row)" [ngStyle]="{'color': row.cor}"></i>
                                </div>
                                <div class="monitoring-content">
                                    <span class="monitoring-name">{{ row.tipo_evento }}</span>
                                    <span class="monitoring-dates" pTooltip="Inicio / Fim">
                                        {{ row.data_hora_monitoramento }} / {{ row.data_hora_ultima_situacao }}
                                    </span>
                                </div>
                                <span class="monitoring-status"
                                    [class.monitoring-status-open]="monitoramentoEstaAberto(row)"
                                    [class.monitoring-status-closed]="!monitoramentoEstaAberto(row)">
                                    {{ monitoramentoEstaAberto(row) ? 'Aberto' : 'Fechado' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="modal-footer">
            <button pButton pRipple type="button" icon="pi pi-table" (click)="abrirLeiturasEstacao()"
                label="Ver leituras do dia" class="p-button-outlined p-button-info"
                [disabled]="loading || !estacao?.id"></button>
            <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="changeDate('ontem')"
                label="Data anterior" class="p-button-outlined"></button>
            <button pButton pRipple type="button" (click)="changeDate('amanha')" iconPos="right"
                icon="pi pi-arrow-right" label="Próxima data" class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<app-leitura-estacao-dialog></app-leitura-estacao-dialog>
<app-eventos-monitoramentos-dialog
    (saved)="onMonitoramentoSalvo()">
</app-eventos-monitoramentos-dialog>

<p-dialog [(visible)]="modalNovoGrupo" header="Novo Grupo de estações"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}">
    <app-grupo-estacao-formulario *ngIf="modalNovoGrupo" (onSave)="aoSalvarNovoGrupo()"></app-grupo-estacao-formulario>
</p-dialog>
